export const affiliate = {
  seo: {
    title: "Bespire Affiliate Program - Keress €300-t minden ajánlással",
    description: "Csatlakozz a Bespire affiliate programjához! Keress €300-t minden sikeres ajánlás után. Ingyenes regisztráció, azonnali link generálás.",
    keywords: "affiliate program, partner program, jutalék, kereseti lehetőség, Bespire"
  },
  navigation: {
    howItWorks: "Hogyan működik",
    benefits: "Előnyök",
    calculator: "Kalkulátor", 
    getStarted: "Kezdjük el",
    backToHome: "Vissza a főoldalra"
  },
  hero: {
    badge: "Bespire ajánlói program",
    title: {
      earn: "Keress",
      amount: "€300-t",
      withEvery: "minden ajánlással"
    },
    description: "Ajánld a Bespire-t másoknak és keress komoly pénzt! Teljesen ingyenes a csatlakozás, nincs rejtett díj, csak tiszta profit.",
    buttons: {
      getStarted: "Kezdjük el most!",
      howItWorks: "Hogyan működik?"
    }
  },
  stats: {
    commission: {
      value: "€300",
      label: "Jutalék mértéke"
    },
    threshold: {
      value: "€3000",
      label: "Után fizető"
    },
    registration: {
      value: "€0",
      label: "Regisztráció"
    },
    referrals: {
      value: "∞",
      label: "Ajánlások száma"
    }
  },
  steps: {
    title: "Ilyen egyszerű",
    description: "4 lépésben tudsz pénzt keresni - nincs bonyolult folyamat, csak eredmény",
    items: [
      {
        title: "1. Regisztrálj",
        description: "Csak egy email cím kell - teljesen ingyenes!"
      },
      {
        title: "2. Kapd meg a linkedet",
        description: "Azonnal megkapod az egyedi affiliate linkedet"
      },
      {
        title: "3. Oszd meg",
        description: "Küldd el barátaidnak, követőidnek, mindenkinek!"
      },
      {
        title: "4. Keress pénzt",
        description: "€300 jutalék minden sikeres ajánlás után"
      }
    ]
  },
  benefits: {
    title: "Miért érdemes csatlakozni?",
    description: "A legjobb feltételek és a legnagyobb jutalékok várnak rád",
    items: [
      {
        title: "Nagy jutalék",
        description: "€300 minden sikeres ajánlás után - ez az egyik legmagasabb a piacon!"
      },
      {
        title: "Gyors kifizetés",
        description: "Amint az ajánlott creator eléri a €3000 értékesítést, azonnal utalunk"
      },
      {
        title: "Segítesz másoknak", 
        description: "A creatorok számára nyújtasz lehetőséget az önmegvalósításra"
      },
      {
        title: "Nincs limit",
        description: "Annyi embert ajánlhatsz, amennyit csak szeretnél"
      }
    ]
  },
  calculator: {
    title: "Mennyit kereshetsz?",
    description: "Számold ki, mekkora bevételre számíthatsz az ajánlásaiddal",
    scenarios: [
      {
        referrals: "1",
        title: "ajánlás",
        amount: "€300",
        description: "Egy sikeres ajánlás után"
      },
      {
        referrals: "5",
        title: "ajánlás", 
        amount: "€1500",
        description: "Már egy szép mellékjövedelem"
      },
      {
        referrals: "10",
        title: "ajánlás",
        amount: "€3000", 
        description: "Akár főállásnak is megfelelő"
      }
    ],
    note: {
      title: "Fontos:",
      description: "Nincs limit! Annyi embert ajánlhatsz, amennyit csak szeretnél. Minden sikeres ajánlás után €300 jutalékot kapsz."
    }
  },
  registration: {
    title: "Kezdjük el most!",
    description: "Regisztrálj most és máris megkapod az egyedi affiliate linkedet",
    form: {
      email: "Email címed",
      confirmEmail: "Email megerősítése",
      password: "Jelszó",
      emailPlaceholder: "pelda@email.com",
      passwordPlaceholder: "••••••••",
      submitButton: "Regisztrálok és kapom a linkem!",
      submitting: "Regisztráció folyamatban..."
    },
    benefits: [
      "Teljesen ingyenes regisztráció",
      "Azonnali link generálás",
      "€300 jutalék minden sikeres ajánlás után", 
      "Nincs limit az ajánlások számában"
    ]
  },
  faq: {
    title: "Gyakori kérdések",
    description: "Itt találod a leggyakrabban felmerülő kérdéseket az affiliate programunkról",
    questions: [
      {
        question: "Mennyi a jutalék mértéke?",
        answer: "Minden sikeres ajánlás után €300 jutalékot fizetek. Ez akkor jár, amikor az általad ajánlott creator eléri a €3000 értékesítést a platformon."
      },
      {
        question: "Mikor kapom meg a jutalékomat?",
        answer: "A jutalékot azonnal utalunk, amint az ajánlott creator eléri a €3000 értékesítést. Nincs várakozási idő, nincs feltétel."
      },
      {
        question: "Van limit az ajánlások számában?",
        answer: "Nincs! Annyi embert ajánlhatsz, amennyit csak szeretnél. Minden sikeres ajánlás után megkapod a €300 jutalékot."
      },
      {
        question: "Mit kell tennem a regisztráció után?",
        answer: "A regisztráció után azonnal megkapod az egyedi affiliate linkedet. Ezt csak meg kell osztanod másokkal - emailben, social médiában, bárhol."
      },
      {
        question: "Hogyan követhetem nyomon az ajánlásaimat?",
        answer: "A regisztráció után hozzáférést kapsz egy egyszerű dashboardhoz, ahol valós időben követheted az ajánlásaidat és a jutalékaidat."
      },
      {
        question: "Kell valamit fizetnem?",
        answer: "Egyáltalán nem! A regisztráció teljesen ingyenes, nincs rejtett díj, nincs havi költség. Csak keresni tudsz, fizetni nem kell semmit."
      },
      {
        question: "Milyen támogatást kapok?",
        answer: "Teljes támogatást nyújtunk: marketing anyagokat, bannereket, szövegeket és személyes segítséget is, hogy minél több sikeres ajánlást tudj generálni."
      },
      {
        question: "Mikor számít sikeresnek egy ajánlás?",
        answer: "Akkor, amikor valaki a te affiliate linkedről regisztrál és eléri a €3000 értékesítést a platformon. Ez után automatikusan megkapod a €300 jutalékot."
      }
    ],
    contactPrompt: "További kérdésed van? Írj nekünk!",
    contactButton: "Kapcsolat"
  },
  footer: {
    company: {
      description: "Építsd fel alkotói birodalmadat AI-vezérelt eszközökkel"
    },
    features: {
      title: "Funkciók",
      howToStart: "Hogyan kezd el",
      whatToSell: "Mit adhatsz el",
      partnerProgram: "Partner program",
      pricing: "Árazás"
    },
    support: {
      title: "Támogatás",
      privacy: "Adatvédelem",
      terms: "Feltételek",
      aboutUs: "Rólunk"
    },
    newsletter: {
      title: "Hírlevelünk",
      description: "Iratkozz fel hírlevelünkre a legfrissebb újdonságokért és tippekért!",
      emailPlaceholder: "Email címed",
      subscribeButton: "Feliratkozás"
    },
    bottom: {
      copyright: "© 2024 Bespire. Minden jog fenntartva.",
      madeWithLove: "Szeretettel fejlesztve ❤️",
      systemStatus: "Rendszer működik"
    }
  }
};